function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 60",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-138,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter",
    transform: "matrix(1.61997,0,0,1.61997,23.7302,-15.3389)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.617296,0,0,0.617296,72.1017,9.2569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.837,15.065C51.026,15.87 49.077,16.413 47.032,16.656C49.12,15.406 50.721,13.426 51.476,11.064C49.523,12.223 47.361,13.064 45.058,13.518C43.215,11.554 40.588,10.326 37.681,10.326C32.1,10.326 27.575,14.851 27.575,20.433C27.575,21.224 27.664,21.995 27.837,22.736C19.437,22.314 11.989,18.291 7.004,12.176C6.134,13.668 5.636,15.404 5.636,17.258C5.636,20.764 7.42,23.858 10.132,25.67C8.476,25.617 6.917,25.162 5.554,24.405C5.553,24.447 5.553,24.49 5.553,24.533C5.553,29.429 9.037,33.513 13.661,34.443C12.813,34.673 11.92,34.797 10.998,34.797C10.346,34.797 9.713,34.734 9.096,34.615C10.383,38.63 14.115,41.553 18.537,41.634C15.078,44.345 10.721,45.961 5.985,45.961C5.17,45.961 4.365,45.913 3.574,45.819C8.048,48.688 13.36,50.36 19.067,50.36C37.658,50.36 47.823,34.96 47.823,21.604C47.823,21.166 47.814,20.729 47.795,20.295C49.769,18.873 51.483,17.092 52.837,15.065Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.dcdc494a.svg";
export { ForwardRef as ReactComponent };